// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"65":"a749ee41eff9d6b3","272":"a3c02353762e1fc9","467":"146008111b858dac","640":"483a96faaa122546","874":"7024f0b6e4389b2d"}[chunkId] + ".js";
};